// src/utils/firestoreCache.ts
//
// Má Firestore trvalou mezipaměť (IndexedDB)? Bez ní (soukromý režim, plné
// úložiště, starý WebView) SDK tiše spadne na paměťovou mezipaměť – fronta
// zápisů pak zabitím aplikace zmizí. Obrazovka rozhodčího proto bez trvalé
// mezipaměti ukládá výsledek blokujícím způsobem jako dřív (čeká na server),
// místo aby rozhodčího pustila k dalšímu střelci (docs/live-faze3-navrh.md,
// bod 5.4). SDK pád hlásí jen varováním v logu – firebase.ts ho sem předá
// (onLog z firebase/app).

let memoryOnly = false;

/** Záznam logu Firebase (onLog): pád na paměťovou mezipaměť si poznamená. */
export function noteFirebaseLog(entry: { type?: string; message?: string }): void {
  if (entry && entry.type === "@firebase/firestore" && typeof entry.message === "string" &&
      entry.message.indexOf("Falling back to memory cache") >= 0) {
    memoryOnly = true;
  }
}

/** Fronta zápisů přežije zabití aplikace (trvalá mezipaměť IndexedDB). */
export function firestoreQueueDurable(): boolean {
  return !memoryOnly;
}

/** Jen pro testy: nastaví, zda Firestore běží jen s paměťovou mezipamětí. */
export function setFirestoreMemoryOnlyForTests(value: boolean): void {
  memoryOnly = value;
}
